export default __webpack_public_path__ + "static/media/backgroundimage.ad0ad7b9.png";